import { gql } from '@apollo/client'

export default gql`
  query getCreditCards($category: String, $slug: String, $limit: Int) {
    creditCards(slug: $slug, category: $category, limit: $limit) {
      name
      slug
      image
      url
      issuerPublicName
      annualFeeFormatted
      ratesAndFeesUrl
      introBalanceTransferPeriodFormatted
      introPurchaseAprPeriodFormatted
      balanceTransferFeeFormatted
      rewardsUnit
      introBonusPoints
      introBonus
      featuredCategory {
        slug
      }
      rewardsRate
      creditNeeded
      securityDepositMinimum
      aprRangeFormatted
      marketingBullets{
        bullet
        uuid
      }
    }
  }
`
